module.exports = __webpack_public_path__ + "img/6.339b19b.svg";